/**
 * Global scripts for the theme. Stuff that we need all the time on every page.
 */
"use strict";

(function($, once) {
  // Quick and dirty CSS breakpoint checker.
  window.lu_isBP = function (breakpoint) {
    var breakpoints = ['small', 'medium', 'large', 'xlarge'],
      index = breakpoints.indexOf(breakpoint);
    if (index === -1) {
      return false;
    }
    var bitmask = Math.pow(2, index), cssint = parseInt($('head').css('margin-left'));
    return (cssint & bitmask) > 0;
  }

  // Modal manager.
  var modals = [];
  window.lu_showModal = function(id, element_root, toggle_callback, data) {
    // Close all previous modals.
    var modal = null;
    while (modal = modals.pop()) {
      if (modal.id !== id) {
        modal.toggle_callback(false);
      }
    }
    toggle_callback(true, data);
    modals.push({ id: id, toggle_callback: toggle_callback, element_root: element_root });
    $(document.documentElement).toggleClass('modal-shown', modals.length > 0);
  }
  window.lu_hideModal = function(id) {
    for (var i = 0; i < modals.length; ++i) {
      if (!id || modals[i].id === id) {
        modals[i].toggle_callback(false);
        modals.splice(i, 1);
        break;
      }
    }
    $(document.documentElement).toggleClass('modal-shown', modals.length > 0);
  }

  if (window.location.pathname === '/news/archive') {
    $(function () {
      // change title on page load
      const page_load_category = $('select[name="field_news_category_target_id"]').find(":selected").val();
      if (page_load_category !== 'All' && page_load_category != null) {
        $('#block-lawrence-theme-page-title h1').text('News - Category: ' + jQuery('select[name="field_news_category_target_id"]').find(":selected").text());
      }
      // get query params to check for tag and set title
      const url_params = new URLSearchParams(window.location.search);
      const tag_name = url_params.get('field_tags_target_id');
      if (tag_name !== '' && tag_name != null) {
        $('#block-lawrence-theme-page-title h1').text('News - Tag: ' + tag_name.replace(/\s*\(.*?\)\s*/g, ''));
      }
        // change title when select box changes
      $('body').on('change', 'select[name="field_news_category_target_id"]', function () {
        if ($(this).find(":selected").val() === 'All') {
          $('#block-lawrence-theme-page-title h1').text('All News');
        } else {
          $('#block-lawrence-theme-page-title h1').text('News - Category: ' + jQuery(this).find(":selected").text());
        }
      });
      $('body').on('change', 'input[name="field_tags_target_id"]', function () {
        if ($(this).val() === '' || $(this).val() == null) {
          $('#block-lawrence-theme-page-title h1').text('All News');
        } else {
          // remove the tag ID from the title
          $('#block-lawrence-theme-page-title h1').text('News - Tag: ' + jQuery(this).val().split('(')[0].replace(/\s*\(.*?\)\s*/g, ''));
        }
      });
    });
  }

  Drupal.behaviors.lu_theme = {
    attach: function (context, settings) {
      window.lu_disable_animations = !!(Cookies.get('lu-da') || false);
      // JDS - disabling all animations for now until Chrome fixes itself
      //window.lu_disable_animations = true;
      // Add our Google font, which we do async style to prevent blocking.
      // CKOD
      /*
      $('head').once('lu_theme.googlefont').append($('<link rel="preload" media="all" as="style" onload="this.rel=\'stylesheet\'">')
        .attr('href', "https://fonts.googleapis.com/css2?family=Lora:ital@0;1&display=swap"));
      $('head').once('lu_theme.googlefont2').append($('<link rel="preload" media="all" as="style" onload="this.rel=\'stylesheet\'">')
        .attr('href', "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,600;1,400;1,600&display=swap"));
      */
      // jquery once to core once
      //$('head').once('lu_theme.googlefont2').append($('<link rel="preload" media="all" as="style" onload="this.rel=\'stylesheet\'">')
      //  .attr('href', "https://use.typekit.net/vnl4adk.css?family=ivypresto-headline:normal,wght@0,100;1,400&display=swap"));
      $(once('lu_theme.googlefont2', 'head')).each(function(){
        $(this).append($('<link rel="preload" media="all" as="style" onload="this.rel=\'stylesheet\'">')
        .attr('href', "https://use.typekit.net/vnl4adk.css?family=ivypresto-headline:normal,wght@0,100;1,400&display=swap"));
      });
      // Set this class right away so that things which need to trigger ASAP
      // (like hero gold bars) can do whatever they do to hide until animations
      // load.
      if (!window.lu_disable_animations) {
        $(document.body).addClass('animations-potential');
      }
      // Super gross hack to add the current page to login links, because doing
      // this in Drupal w/menu alters was a pain and caching was dubious.
      // jquery once to core once
      //$('a[href$="/user/login"]').once('lu_theme.login_links').each(function() {
      $(once('lu_theme.login_links', 'a[href$="/user/login"]')).each(function() {
        this.href += '?destination=' + window.location.pathname;
      });
      // Set up the button - change its state based on any cookie value.
      var fnUpdateAnimationsState = function() {
        var $button = $('.menu-animation-toggle');
        if (window.lu_disable_animations) {
          $button.html($button.html().replace(/Disable/, 'Enable').replace(/disable/, 'enable'));
        }
        else {
          $button.html($button.html().replace(/Enable/, 'Disable').replace(/enable/, 'disable'));
        }
        $(document.body).toggleClass('animations-off', window.lu_disable_animations);
        $(document.body).toggleClass('animations-on', !window.lu_disable_animations);
        $(document.body).toggleClass('animations-potential', !window.lu_disable_animations);
      };
      // jquery once to core once
      //$(window).once('lu_theme.animations').on('load', function() {
      $(once('lu_theme.animations', 'html')).each(function(){
        // If animations are enabled, wait for any to load (more than $duration
        // in SCSS) and, after sufficient delay for animations to load to their
        // normal state, enable animations.
        setTimeout(function enableAnimations() {
          fnUpdateAnimationsState();
        }, 375);
        //console.log('window animations on load ran');
      });
      // jquery once to core once
      //$('.menu-animation-toggle', context).once('lu_theme.animations').click(function(event) {
      $(once('lu_theme.animations', '.menu-animation-toggle', context)).each(function(){
        $(this).click(function(event) {
          // Toggle the setting, then react.
          window.lu_disable_animations = !window.lu_disable_animations;
          if (window.lu_disable_animations) {
            Cookies.set('lu-da', '1', { expires: 180 })
          }
          else {
            Cookies.remove('lu-da');
          }
          event.stopPropagation();
          fnUpdateAnimationsState();
        });
      });

      // jquery once to core once
      //$(document.documentElement).once('lu_theme.modals').click(function(event) {
      $(once('lu_theme.modals', document.documentElement)).each(function(){
        $(this).click(function(event) {
          // Intercept any clicks that occur outside of our modals, and close
          // them (but only check if we actually are showing modals).
          if (modals.length) {
            for (var i = 0; i < modals.length; ++ i) {
              if ($(event.target).closest(modals[i].element_root).length > 0) {
                return;
              }
            }
            event.preventDefault();
            lu_hideModal();
          }
        });
      });

      var menuToggle = function(state, event) {
        $(document.documentElement).toggleClass('nav-menu-shown', state);
        if (state) {
          // Showing modal.
          // Was it the search button or menu button that was clicked?
          var $focus = $('#lu-search-ajax-keys');
          if ($(event.target).closest('.menu-search-toggle').length === 0) {
            $focus = $('#nav-menu > .outer-wrapper');
            $focus.attr('tabindex', 0);
          }
          setTimeout(function() { $focus.focus(); }, 100);
        }
        else {
          // Hiding modal.
          $('#nav-menu > .outer-wrapper').attr('tabindex', null);
          // Reset the search field and notify the event listener stuff.
          $('#lu-search-ajax-keys').val('').trigger('input.lu-search-ajax');
        }
      };
      var menuButtonToggle = function(event) {
        // Register this modal, so it can be closed by other modals.
        if (!$(document.documentElement).hasClass('nav-menu-shown')) {
          lu_showModal('global-nav-menu', $('#nav-menu'), menuToggle, event);
        }
        else {
          lu_hideModal('global-nav-menu');
        }
        event.stopPropagation();
        event.preventDefault();
      };
      // jquery once to core once
      //$('.menu-toggle', context).once('lu_theme').click(menuButtonToggle);
      $(once('lu_theme', '.menu-toggle', context)).each(function(){$(this).click(menuButtonToggle);});

      // jquery once to core once
      //$('.node--video_card--card', context).once('lu_theme').find('.field--name-field-video').each(function() {
      $(once('lu_theme', '.node--video_card--card', context)).find('.field--name-field-video').each(function() {
        var videoCat = $('.node--video_card--card > div.field--name-field-news-category');
        videoCat.text('Video');
        // Add "Play video" button to video cards.

          // var $btn = $('<div class="field">'), _this = this;
          // $('<a class="button button-arrow">Play video</a>')
          //   .attr('href', $(this).find('a').attr('href'))
          //   .click(function(e) {
          //     e.preventDefault();
          //     $(_this).find('.media--type-remote-video a').click();
          //   })
          //   .appendTo($btn);
          // $btn.appendTo($(this).parents('.node--video_card--card'));

          // JDS - Make the title a link too (because apparently COMMS thinks good SEO means we need to apply links to every field - probably will want done for every word at some point)
          $(this).siblings('.field--name-field-display-title-plain').children('h2').html(
            '<a href="' + $(this).find('a').attr('href') + '">' + $(this).siblings('.field--name-field-display-title-plain').children('h2').text() + '</a>')
            .click(function(e) {
              e.preventDefault();
              $(_this).find('.media--type-remote-video a').click();
            });
      });

      // Set up floating header.
      // $('#site-header').once('lu_theme').find('.field--name-field-video').each(function() {
      //
      // });
      // Ensure we have a dark logo version, to show while scrolling (white bg).
      // jquery once to core once
      //$('.site-logo img, #site-header .menu-toggles img', context).once('lu_theme').each(function () {
      $(once('lu_theme', '.site-logo img, #site-header .menu-toggles img', context)).each(function () {
        var $this = $(this);
        $this
          .data('og-src', $this.attr('src'))
          .data('scroll-src', $this.attr('src').replace(/-rev\.svg|-white\.svg/, ".svg"));
      });
      var previousScrolled = false;
      var $header = $('#site-header'), $headerAnchor = null;

      // Set up a target element that tracks the effective top edge of the
      // header, if it were still placed on the page (in case there are other
      // items like emergency banners or admin toolbars taking up space above).
      // jquery once to core once
      //$header.once('lu_theme-anchor').each(function() {
      $(once('lu_theme-anchor', $header)).each(function() {
        $headerAnchor = $('<div id="site-header-top-anchor"></div>').insertBefore($header);
      });

      // Initialize our total movement tracker with something bigger than our
      // threshold.
      var movementAmount = 100;
      // jquery once to core once
      //$('.page', context).once('lu_theme')
      $(once('lu_theme', '.page', context))
        .on('scroll-move', function (event) {
          if (!$(event.target).hasClass("page")) {
            return;
          }

          // Calculate the lower vertical bound of the header, if it were still
          // anchored on the page.
          var headerStop = $headerAnchor.offset().top + $header.outerHeight(true);
          // The effective scrollTop is the window.scrollTop plus any other
          // elements like admin toolbars.
          var effectiveScrollTop = $(window).scrollTop() + parseInt(document.body.style.paddingTop || 0);
          // Check if the effective scrollTop is below the bottom of the header,
          // or above the top of the header.
          var belowBottom = effectiveScrollTop - headerStop >= 0,
            aboveTop = $headerAnchor.offset().top - effectiveScrollTop >= 0;

          // If there's an emergency banner (or maybe over time other things),
          // which push the statically positioned header down, pull it back up
          // when we switch to a fixed position.
          var marginTop = $('.lu-emergency-alert-banner').outerHeight();
          if (!!marginTop) {
            $header.css('margin-top', -marginTop + "px");
          }

          // Check if we've now scrolled below the static header, triggering
          // our floating header. previousScrolled is just a debounce so we run
          // the transition phase only once.
          if (belowBottom && !previousScrolled) {
            $header.addClass('scrolled');
            // Flip images.
            $('.site-logo img, #site-header .menu-toggles img').each(function () {
              $(this).attr('src', $(this).data('scroll-src'));
            });
            previousScrolled = true;
              $header.addClass('scrolled-transition');
              setTimeout(function() {
                $header.removeClass('scrolled-transition');
              }, 350);
          }
          // If we've scrolled back above the top of where the header rests,
          // stop floating. scrollTop() === 0 is just a sanity check, aboveTop
          // should be correct.
          else if ($(window).scrollTop() === 0 || aboveTop) {
            $header.removeClass('scrolled');
            // Flip images.
            $('.site-logo img, #site-header .menu-toggles img').each(function () {
              $(this).attr('src', $(this).data('og-src'));
            });
            previousScrolled = false;
          }
          // We do *not* want to apply a movement threshold to this value.
          $header.toggleClass('page-scrolled', $(window).scrollTop() > 0);

          // Scrolling up, in general? Use to show some elements.
          // Tally the amount of actual movement, so we can smooth out some
          // over-sensitivity in hiding/showing stuff.
          // Negative distance means traveling up the page, positive is
          // scrolling downward.
          movementAmount += event.distance;
          if (Math.abs(movementAmount) >= 15 || $(window).scrollTop() === 0) {
            $header.toggleClass('docked', (event.direction === "down"));
            $(event.target).toggleClass('scrolling-up', (event.direction === "up"));
            $(event.target).toggleClass('scrolling-down', (event.direction !== "up"));
            movementAmount = 0;
          }
        })
        .scrollSpy();

      // $('#sidebar-inset', context).once('lu_theme')
      //   .on('scroll-move', function (event) {
      //     $(this).toggleClass('scrolled', !!event.belowTop);
      //   })
      //   .scrollSpy();

      // News search. Yes this is not the best place for this, it should be its
      // own library, added properly. But this will work and we have no time to
      // do the Right Thing(tm).
      // jquery once to core once
      //$('.view-id-lu_news_blog .views-exposed-form', context.parentElement || context).once('lu_theme')
      $(once('lu_theme', '.view-id-lu_news_blog .views-exposed-form', context.parentElement || context))
        .find('select[name=field_news_category_target_id],select[name=field_profiles_category_target_id]').each(function(){
          $(this).on('change', function() {
            $(this).parents('form').find('.form-submit').click();
          });
        });

      // Floating "Section Menu" interior navigation block.
      var $floating_nav = null, $nav_toggle = null;
      var debounceTimer = null;
      var fnInteriorNavToggle = function(state) {
        $floating_nav.toggleClass('nav-hidden', !state);
        $floating_nav.toggleClass('nav-shown', state);
        // Fix animations so slide-out doesn't actually animate on first display.
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        if (state) {
          $floating_nav.addClass('nav-was-shown')
            .attr('tabindex', '0');
          setTimeout(function() { $floating_nav.focus(); }, 100);
        }
        else {
          $floating_nav.attr('tabindex', null);
          // Roughly match the ms delay here to the $duration value in SCSS.
          debounceTimer = setTimeout(function() { $floating_nav.removeClass('nav-was-shown'); }, 350);
        }

        $nav_toggle
          .text(state ? 'Close Menu' : 'Section Menu')
          .attr({
            "aria-expanded": !!state
          });
      };
      var fnInteriorNavButtonToggle = function(event) {
        // Register this modal, so it can be closed by other modals.
        if (!$floating_nav.hasClass('nav-shown')) {
          lu_showModal('interior-nav-menu', $floating_nav, fnInteriorNavToggle, event);
        }
        else {
          lu_hideModal('interior-nav-menu');
        }
        event.stopPropagation();
      };
      var fnPrepareFloatingNav = function(parent) {
        if (!$floating_nav) {
          $floating_nav = $('<div class="floating-nav nav-hidden" aria-labelledby="interior-nav-toggle">').appendTo(parent);
        }
        if (!$nav_toggle) {
          // adding section-menu class to appease Ken's inane need to not hide this on mobile - see _floating_toc.scss line 219
          $nav_toggle = $('<button id="interior-nav-toggle" class="nav-toggle section-menu" aria-label="Section Menu navigation toggle">Section Menu</button>')
            .on('click', fnInteriorNavButtonToggle)
            .insertBefore($floating_nav);
        }
        // Clone the nav.
        $floating_nav.html(
          '<div class="h5">Section Menu</div>' +
          $(parent).find('.menu').prop('outerHTML').replace(/\sid=(['"])/gi, ' id=$1nav-copy-').replace(/\sdata-[^\s]+?=(['"]).*?\1/gi, '')
        );
        var $nav_toggle_scnd = $('<button type="button" class="nav-toggle-secondary">Close <span class="visually-hidden">Section Menu menu</span> &nbsp; <img src="/themes/custom/lawrence_theme/img/icon-close.svg" alt="" width="23" height="23"></button>')
          .on('click', function() { lu_hideModal('interior-nav-menu'); })
          .prependTo($floating_nav);
      }
      var breakpoint_bottom_menu_flip = 'medium';
      // jquery once to core once
      //$('#block-site-structure', context).once('lu_theme.floating_nav')
      $(once('lu_theme.floating_nav', '#block-site-structure', context))
        .each(function() {
          fnPrepareFloatingNav(this);
        })
        .on('scroll-new-third', function (event) {
          // Check if we've scrolled down the page, and the nav is now above
          // the viewport.
          $(this)
            .toggleClass('scrolled', event.newThird === 'above')
            .trigger({
              type: 'interior-nav-affix',
              affixed: event.newThird === 'above'
            });
        })
        .on('interior-nav-affix', function (event) {
          if (event.affixed) {
            fnPrepareFloatingNav(event.target);
          }
          else {
            // Ensure we close up any open drawers.
            if (lu_isBP(breakpoint_bottom_menu_flip)) {
              setTimeout(function() { lu_hideModal('interior-nav-menu'); }, 0);
            }
          }
        })
        .scrollSpy({ topOffset: function(vh) { return parseInt($('body').css('padding-top') || 0) } });

      // On-Scroll region effects - mostly handled via CSS, but trigger w/JS.
      // jquery once to core once
      //$('.effect-on-scroll', context).once('lu_theme.animations').each(function() {
      $(once('lu_theme.animations', '.effect-on-scroll', context)).each(function() {
        // Scroll effects are registered on layout containers, but apply to
        // the paragraphs therein.
        $('.layout__region .paragraph:not(.layout__region .paragraph .paragraph)', this)
          .addClass('effect-target')
          .scrollSpy({ topOffset: function(vh) { return parseInt($('body').css('padding-top') || 0) } });
      });
      // jquery once to core once
      //$('.effect-on-outer-scroll', context).once('lu_theme.animations').each(function() {
      $(once('lu_theme.animations', '.effect-on-outer-scroll', context)).each(function() {
        // Scroll effects are registered on layout containers, and that's where
        // we apply them.
        $(this)
          .addClass('effect-target')
          .scrollSpy({ topOffset: function(vh) { return parseInt($('body').css('padding-top') || 0) } });
      });
      $(document).on('scroll-new-third', '.effect-target', function(event) {
        if (event.newThird === 'visible' || event.newThird === 'above') {
          $(this).addClass('effect-scrolled');
        }
      });

      // Fly-out clone of the main menu (on mobile) needs some accordion
      // functionality.
      // Base this on https://www.w3.org/WAI/tutorials/menus/flyout/.
      // jquery once to core once
      //$('#nav-menu .menu--main > .menu', context).once('lu_theme.flyoutmenu').each(function() {
      $(once('lu_theme.flyoutmenu', '#nav-menu .menu--main > .menu', context)).each(function() {
        var $main_menu_items = $('> .menu-item.menu-item--expanded', this);

        $main_menu_items.each(function() {
          var $menu = $(this), debounceTimer = null;
          $menu.addClass('submenu-closed');
          var label = $menu.find('> a')
            .attr({
              'aria-haspopup': 'true',
              'aria-expanded': 'false'
            }).text();
          var $button = $('<button aria-expanded="false" class="nav-expand-button"></button>')
            .append($('<span class="visually-hidden"></span>').text('Toggle submenu for "' + label + '"'))
            .click(function() {
              var new_state = !$menu.hasClass('submenu-open');
              $menu
                .toggleClass('submenu-closing', !new_state)
                .toggleClass('submenu-open', new_state)
                .attr({ 'aria-expanded': new_state ? 'true' : 'false' });
              $button.attr({ 'aria-expanded': new_state ? 'true' : 'false' });
              if (!new_state) {
                if (debounceTimer) {
                  clearTimeout(debounceTimer);
                }
                debounceTimer = setTimeout(function() {
                  $menu.addClass('submenu-closed');
                  $menu.removeClass('submenu-closing');
                }, 350);
              }
              else {
                $menu.removeClass('submenu-closed');
              }
            })
            .insertAfter($menu.find('> a'));
        });
      });

      // onclick slider controls for news article slider
      $('.slick__slide').on("click", function () {
        // get slide number of slide clicked and move to it
        var slide_num = $(this).prop('class').split('--')[1].split(' ')[0];
        $('.slick__slider').slick('slickGoTo', slide_num);
      });

      // remove video poster for slick slider videos
      $('.media--slick video').removeAttr('poster');

      // get slides' caption image src and insert it as thumbnail image
      $('.slide__description img').each(function () {
        var caption_image_src = $(this).prop('src');
        // get slide number (I know this is hacky but it works great) and replace thumbnail src
        var slide_num = ".slide--" + $(this).parents('.slick__slide').prop('class').split('--')[1].split(' ')[0];
        $(slide_num + ' img').prop('src', caption_image_src);
        $(this).remove();
      });

      // change some aspects of the See More button under the gallery
      var see_more_button = $('.field--name-field-see-more a');
      see_more_button.addClass('button button-arrow');
      see_more_button.text('See More');

      // news category color class applier
      $('.node--article--card > .field--name-field-news-category, .node--article--card > .field--name-field-profiles-category, .node--video_card--card > .field--name-field-news-category, .node--snapshot--card > .field--name-field-snapshot-type, .node--article--card > .field--name-field-bjorklunden-category')
          .each(function() {
        var category_name = this.textContent;
        var normalized_category_name = category_name.replaceAll(' ', '_').replaceAll('&', 'and');
        var catcolor_name = 'catcolor-' + normalized_category_name;
        this.classList.add(catcolor_name.toLowerCase());

        if (this.children.length === 0) {
          var category_endcap = document.createElement('div');
          category_endcap.classList.add('category-endcap');
          this.appendChild(category_endcap);
        }
      });
      $('.related-articles .more-link a').each(function() {
        this.classList.add('button');
        this.classList.add('button-arrow');
      });
    }
  };
  // Adjust top offset if there's a navigation toolbar.
  // $(document).on('drupalViewportOffsetChange.toolbar', function(event, offsets) {
  //   $('#nav-menu').css('top', offsets.top || 0);
  // });


  // mobile hero image slides
  function doMobileImageSlides() {

    var $ssSlides = $('.mobile-slide');
    var $ssImages = $('.mobile-image');
    var ssSlideCount = $ssSlides.length;

    var i = 0;
    var ssSlide = 1;

    if (ssSlideCount > 0) { // need to do this with one slide, even when more than one else will be blank for first 5 seconds

      // hide current hero image on mobile, else it shows briefly between slides
      if (window.innerWidth < 810) {
        $('.hero-image .field--name-field-image').css('display', 'none');
      }

      var $ssImage = $ssImages.eq(ssSlide-1);
      var $ssSlide = $ssSlides.eq(ssSlide-1);

      setTimeout( function () {
        $ssImage.fadeIn(150, "linear");
        $ssSlide.addClass('active');
      }, 200);

      if ((ssSlideCount > 1) /* && (window.innerWidth < 810) */) { // don't run this unnecessarily on desktop

        ssSlide = 2; // manually set to 2nd slide since we just showed the first one above

        setInterval( function () {

          if (ssSlide > ssSlideCount) {
            ssSlide = 1;
          }

          var $ssSlide = $ssSlides.eq(ssSlide-1);
          var $ssImage = $ssImages.eq(ssSlide-1);

          //console.log(i, ssSlide, $ssSlide, $ssImage);

          if (i > 0) {
            $ssImages.hide();
          }

          $ssSlides.removeClass('active');
          $ssSlide.addClass('active');

          $ssImage.fadeIn(150, "linear").delay(7700).fadeOut(350, "linear"); // sum must match with timing in _hero.scss (ln 134)

          ssSlide++; i++;

        }, 7800); // sum of above minus 200

      }

    } else { // show original hero image for mobile

      // need to still hide image if on desktop else it will show instead
      /*
      if (window.innerWidth < 810) {
        $('.hero-image .field--name-field-image').fadeIn(150, 'linear');
      }
      */
    }
  }

  $(function() {

    // hero text - call slick if necessary and unhide
    if ($('.hero-slide').length) {
      $('.hero-text').slick({
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        fade: true,
        // vertical: true, // does not work with "fade"
        adaptiveHeight: true,
        speed: 1000
      });
      $('.hero-slide').css('display', 'block');
    }

    // hero mobile image slideshow - only run if on mobile breakpoint
    //if (isThisMobile()) {
    //if (window.innerWidth < 810) {
      doMobileImageSlides();
    //}
    // NOTE: hiding mobile slides via CSS (_hero.scss), tho would be nice
    // to not run this on desktop unnecessarily
  });


  function isThisMobile() {
    if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)) {
      return true;
    }
    return false;
  }

  function ytfixbtn(elem) {

    var btnurl = $(elem).attr('href');

    if (btnurl.includes('youtube.com') || btnurl.includes('youtu.be')) {

      // get the youtube video id
      var ytid = 'dQw4w9WgXcQ';
      var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = btnurl.match(regExp);

      if (match && match[2].length == 11) {
        ytid = match[2];
        $(elem).attr('href', 'https://www.youtube.com/embed/' + ytid + '?rel=0&wmode=transparent&autoplay=1');
        if(isThisMobile()) {
          $(elem).colorbox({iframe:true, width:"90%", height:"75%", scrolling:false, overlayClose:true, opacity:0.5, close:"Close", closeButton:false});
        } else {
          $(elem).colorbox({iframe:true, width:"75%", height:"75%", scrolling:false, overlayClose:true, opacity:0.5, close:"Close", closeButton:false});
        }
      } else {
        //error
      }
    }
  }

  function ytmodal() {

    /*
    if (alreadyRan) {
      //return;
    }
    alreadyRan = true;
    */

    //console.log('ytmodal scripts.js');

    // hero text desktop, mobile
    $('#hero .hero-text .region-hero a').each(function(i,elem) {
      ytfixbtn(elem);
    });

    // wayfinding paragraphs desktop, mobile
    $('.paragraph--type--wayfinding .field--name-field-link a').each(function(i,elem) {
      ytfixbtn(elem);
    })

    // fix the colorbox overlay
    $('#cboxOverlay').css('height', $(document).height() + 'px');
    $('#cboxOverlay').css('width', $(document).width() + 'px');
  }

  ytmodal();

})(jQuery, once);
